<template>
  <div
    class="container mx-auto p-6 pt-2 max-w-4xl bg-white shadow-md rounded-lg"
  >
    <div v-if="loading" class="text-center">
      {{ $translate("Loading, please wait...") }}
    </div>
    <div v-else-if="content">
      <div class="legal-container" v-html="content"></div>
    </div>
    <div v-else class="text-red-500">
      {{ $translate("Failed to load content.") }}
    </div>
  </div>
</template>

<script>
export default {
  name: "TermsPage",
  data() {
    return {
      content: null, // Holds the fetched content
      loading: true, // Indicates if data is being loaded
    };
  },
  mounted() {
    this.fetchLegalPage();
  },
  methods: {
    async fetchLegalPage() {
      try {
        const response = await fetch(
          "https://webwire.cz/api/v2/brand/legal-pages",
          {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: new URLSearchParams({
              brand_id: window.vueAppConfig.info.id, // Adjust the brand slug as needed
              page: "terms", // Fetching the privacy page
            }),
          }
        );

        const data = await response.json();

        if (data.status) {
          // Assuming 'data' contains the actual legal page content in 'data.data'
          if (data.data) {
            this.content = data.data;
          } else {
            this.loading = false;
          }
        } else {
          console.error("Failed to fetch legal page:", data.message);
        }
      } catch (error) {
        console.error("Fetch legal page failed:", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
/* --- Base Styles for Dynamic Content --- */
.legal-container {
  line-height: 1.6;
  color: #374151; /* gray-700 */
  font-family: sans-serif; /* Or your preferred font */
}

.legal-container p {
  margin-bottom: 0.75rem;
  text-align: justify;
}

.legal-container a {
  color: #2563eb; /* blue-600 */
  text-decoration: underline;
}
.legal-container a:hover {
  color: #1d4ed8; /* blue-800 */
}

.legal-container b {
  font-weight: 600; /* semibold */
}

/* --- Ordered List Styling (Nested Decimal) --- */

/* Remove default padding AND ensure no default list style */
.legal-container ol {
  padding-left: 0 !important;
  margin-left: 0 !important;
  list-style: none !important; /* IMPORTANT: Ensure no bullets/numbers */
  margin-bottom: 1rem;
}
.legal-container ul {
  padding-left: 0 !important; /* Remove default padding from the list */
  margin-left: 0 !important; /* Remove default margin from the list */
  list-style: none !important; /* Ensure no bullets/numbers */
}

.legal-container ul li p {
  position: relative !important;
  padding-left: 0 !important; /* Remove default padding from the list */
  margin-left: 0 !important; /* Remove default margin from the list */
}

/* Remove default padding AND ensure no default list style */
.legal-container ol {
  padding-left: 0 !important;
  margin-left: 0 !important;
  list-style: none !important; /* IMPORTANT: Ensure no bullets/numbers */
  margin-bottom: 1rem;
}

/* General LI style */
.legal-container li {
  position: relative;
  padding-left: 2.5rem; /* Base space for counter */
  margin-bottom: 0.5rem;
}

/* Paragraphs inside LI */
.legal-container li p {
  margin-bottom: 0.25rem;
}
.legal-container li p:last-child {
  margin-bottom: 0;
}

/* --- List Counters (Creates 1., 1.1, 1.1.1 style) --- */

/* Level 1 OL */
.legal-container > ol {
  counter-reset: level1;
}
/* Level 1 LI */
.legal-container > ol > li {
  padding-left: 2rem; /* Adjust base padding */
}
.legal-container > ol > li::before {
  counter-increment: level1;
  content: counter(level1) "."; /* Display "1." */
  position: absolute;
  left: 0;
  top: 0.05em;
  font-weight: 600;
  color: #374151;
  width: 1.5rem;
  text-align: right;
  padding-right: 0.5rem;
}

/* Level 2 OL */
.legal-container ol ol {
  counter-reset: level2;
  margin-top: 0.5rem;
}
/* Level 2 LI */
.legal-container ol ol > li {
  padding-left: 2.5rem; /* Increase padding */
}
.legal-container ol ol > li::before {
  counter-increment: level2;
  content: counter(level1) "." counter(level2) "."; /* Display "1.1." */
  position: absolute;
  left: 0;
  top: 0.05em;
  font-weight: 600;
  color: #374151;
  width: 2rem; /* Adjust width */
  text-align: right;
  padding-right: 0.5rem;
}

/* Level 3 OL */
.legal-container ol ol ol {
  counter-reset: level3;
  margin-top: 0.5rem;
}
/* Level 3 LI */
.legal-container ol ol ol > li {
  padding-left: 3rem; /* Increase padding */
}
.legal-container ol ol ol > li::before {
  counter-increment: level3;
  content: counter(level1) "." counter(level2) "." counter(level3) "."; /* Display "1.1.1." */
  position: absolute;
  left: 0;
  top: 0.05em;
  font-weight: 600;
  color: #374151;
  width: 2.5rem; /* Adjust width */
  text-align: right;
  padding-right: 0.5rem;
}

/* --- Styling for Bold Section Headers (like 1. Na úvod) --- */
.legal-container li > p:first-child > b:first-child {
  display: block;
  font-size: 1.1em;
  font-weight: 600;
  margin-top: 0.25rem;
  margin-bottom: 0.5rem;
  color: #1f2937; /* gray-800 */
}
</style>